<template>
	<div class="comment">
		<router-view />
	</div>
</template>
<script>
export default {
	name: "App",
	created() {
	    // 在页面加载时读取localStorage里的状态信息
	    if (localStorage.getItem('store')) {
			this.$store.replaceState(
				Object.assign(
					{},
					this.$store.state,
					JSON.parse(localStorage.getItem('store'))
				)
			)
	    }
	    // 在页面刷新时将vuex里的信息保存到localStorage里
	    // beforeunload事件在页面刷新时先触发
	    window.addEventListener('beforeunload', () => {
			localStorage.setItem('store', JSON.stringify(this.$store.state))
	    })
	},
	methods:{

	}
}
</script>
<style lang="scss">
	::-webkit-scrollbar {
		display: none; /* Chrome Safari */
	}
	// ::-webkit-scrollbar {
	// 	/*滚动条整体样式*/
	// 	width : 6px;  /*高宽分别对应横竖滚动条的尺寸*/
	// 	height: 1px;
	// }
	// ::-webkit-scrollbar-thumb {
	// 	/*滚动条里面小方块*/
	// 	// border-radius: 5px;	
	// 	box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
	// 	background   : #999;
	// }
	// ::-webkit-scrollbar-track {
	// 	/*滚动条里面轨道*/
	// 	box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
	// 	// border-radius: 5px;
	// 	background   : #ededed;
	// }
	body{
		font-size: 12px;
		padding-bottom: 0;
	}
	* {
		box-sizing: border-box;
		padding: 0;
		margin: 0;
		letter-spacing: 1px;
		position: relative;
		// font-size: 0.12rem;
		// color: #2C2C2C;
		// white-space:pre-wrap;
		font-family: "PingFang SC", "Hiragino Sans GB", STHeiti, "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif !important;
	}
	img{
		display: block;
	}
	body{
		background: #F5F5F5;
	}
	a{
		text-decoration:none;
	}
	.flex {
		display: flex;
		flex-wrap: wrap;
	}
	.f-ct {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}
	.f-bt {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.f-bct {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
	}
	.f-w {
		display: flex;
		flex-wrap: wrap;
	}
	.line1 {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.line2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*! autoprefixer: off; */  
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.line3 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*! autoprefixer: off; */  
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}
	.richImg {
		width: 100%;
		height: auto;
		display: block;
	}
	.zw{
		text-align: center;
		padding: 10px 0;
	}
	.ipt-p {
		color: #B5B5B5;
		font-weight: normal;
	}
	.hb_bg {
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 10;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
	}
	
	
	
	// 其他
	.btndef,
	.btndef:focus {
	    position: relative;
	    z-index: 1;
	    text-decoration: none;
	    text-transform: uppercase;
	    overflow: hidden;
	    text-shadow: 0 0 1px rgba(0, 0, 0, 0.2), 0 1px 0 rgba(0, 0, 0, 0.2);
	    -webkit-transition: all 1s ease;
	    -moz-transition: all 1s ease;
	    -o-transition: all 1s ease;
	    transition: all 1s ease;
		
		text-align: center;
		border-radius: 0.1rem;
		background: #304156;
		border: 0.01rem solid #304156;
		color: #fff;
		font-size: 0.16rem;
		cursor: pointer;
	}
	.btndef:after {
	    content: "";
	    position: absolute;
	    height: 0%;
	    left: 50%;
	    top: 50%;
	    width: 150%;
	    z-index: -1;
	    background: #fff;
	    -moz-transform: translateX(-50%) translateY(-50%) rotate(-25deg);
	    -ms-transform: translateX(-50%) translateY(-50%) rotate(-25deg);
	    -webkit-transform: translateX(-50%) translateY(-50%) rotate(-25deg);
	    transform: translateX(-50%) translateY(-50%) rotate(-25deg);
	    -webkit-transition: all 0.75s ease 0s;
	    -moz-transition: all 0.75s ease 0s;
	    -o-transition: all 0.75s ease 0s;
	    transition: all 0.75s ease 0s;
	}
	.btndef:hover {
	    color: #304156;
		font-weight: bold;
	    text-shadow: none;
	}
	.btndef:hover:after {
	    height: 450%;
	}
	// 导航
	.daohang{
		padding-top: 0.24rem;
		padding-left: 0.32rem;
		p{
			color: #999999;
			font-size: 0.18rem;
		}
		a{
			color: #999999;
			font-size: 0.18rem;
			cursor: pointer;
		}
		.now{
			font-size: 0.18rem;
		}
		.el-image{
			width: 0.24rem;
			height: 0.24rem;
		}
		.back{
			cursor: pointer;
			.el-image{
				width: 0.22rem;
				height: 0.22rem;
				margin-right: 0.06rem;
			}
			p{
				color: #2C2C2C;
				font-size: 0.16rem;
			}
		}
	}
	.bigtit{
		color: #304156;
		font-size: 0.18rem;
		padding-left: 0.1rem;
		position: relative;
		font-weight: 550;
		&::after{
			content: '';
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			left: 0;
			width: 0.02rem;
			background: #304156;
			height: 0.15rem;
		}
	}
	// 按钮
	.btn{
		padding: 0 0.12rem;
		height: 0.48rem;
		line-height: 0.48rem;
		border-radius: 0.08rem;
		font-size: 0.18rem;
		background: #393D46;
		text-align: center;
		color: #fff;
	}
	// 返回图片
	.backImg{
		position: fixed!important;
		top: 40px;
		left: 420px;
		width: 78px;
		height: 78px;
	}
	.backImg1{
		position: fixed!important;
		top: 48px;
		left: 520px;
		width: 66px;
		height: 66px;
	}
	.zw{
		padding-top: 60px;
		.el-image{
			width: 310px;
			margin: auto;
			margin-bottom: 32px;
		}
		.t1{
			font-size: 20px;
			text-align: center;
			margin-bottom: 8px;
		}
		.t2{
			color: #999999;
			font-size: 16px;
			text-align: center;
		}
	}
	.allaAnniu{
		width: 100%;
		border-radius: 8px;
		background: #38ABB0;
		text-align: center;
		height: 58px;
		line-height: 58px;
		color: #fff;
		font-size: 18px;
	}
	.snr1{
		color: #38ABB0;
		font-size: 16px;
	}
	.borMT{
		width: 1px;
		height: 16px;
		background: #D9D9D9;
		margin: 0 24px;
	}
	.manMT{
		font-size: 16px;
	}
</style>



